import { DocumentsDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  BulkUpdateFolderDocument,
  BulkUpdateFolderMutation,
  BulkUpdateFolderMutationVariables,
  DocumentsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useBulkUpdateFolderDocument = ({ fromDataTable = false }: { fromDataTable?: boolean }) => {
  const [bulkUpdateFolderMutation, { loading }] = useMutation(BulkUpdateFolderDocument, {
    extractorFn: (data: BulkUpdateFolderMutation) =>
      data.documentsMutations.bulkUpdateFolderDocumentsDocument,
  })

  return {
    loading,
    bulkUpdateFolder(variables: BulkUpdateFolderMutationVariables) {
      return bulkUpdateFolderMutation({
        variables,
        awaitRefetchQueries: true,
        ...(fromDataTable
          ? {
              refetchQueries: [DocumentsDataTableDocument],
            }
          : {
              refetchQueries: [DocumentsDocument],
            }),
      })
    },
  }
}

export default useBulkUpdateFolderDocument
